<section>
  <mds-grid [overrides]="overrides"
            [sizeColumnsToFit]="true"
            [themeClass]="'ag-theme-material'"
            [minHeight]="'400px'"
            (gridReady)="onGridReady($event)"
  ></mds-grid>
</section>





